import type { Messages } from "@/i18n/messages/sq"

export const bs: Messages = {
    meta: {
        lang: "bs",
        dir: "ltr",
        siteTagline: "Izdavaštvo, prijevodi i kursevi",
        siteDescription:
            "Institut Germa je kulturna i obrazovna ustanova koja se bavi izdavaštvom, prevođenjem, kursevima Kur’ana i učenjem stranih jezika."
    },

    languageNames: {
        sq: "Albanski",
        en: "Engleski",
        de: "Njemački",
        es: "Španski",
        tr: "Turski",
        bs: "Bosanski",
        ar: "Arapski"
    },

    common: {
        home: "Početna",
        homeAria: "Institut Germa, početna stranica",
        breadcrumb: "Putanja stranice",
        mainNav: "Glavni meni",
        menu: "Meni",
        openMenu: "Otvori meni",
        closeMenu: "Zatvori meni",
        contactUs: "Kontaktirajte nas",
        language: "Jezik",
        chooseLanguage: "Odaberite jezik stranice",
        instituteName: "Institut Germa"
    },

    nav: {
        libra: "Knjige",
        kurani: "Kur’an",
        videoleksione: "Video lekcije",
        kurse: "Kursevi",
        audiolibra: "Audio knjige",
        rrethNesh: "O nama",
        kontakt: "Kontakt"
    },

    footer: {
        tagline:
            "Izdajemo i prevodimo islamsku literaturu te organizujemo kurseve učenja Kur’ana i stranih jezika.",
        links: "Brzi linkovi",
        books: "Knjige",
        allBooks: "Sve knjige",
        contact: "Kontakt",
        contactNote:
            "Pišite nam ako želite naručiti knjige, prijaviti se na kurs ili predložiti saradnju.",
        rights: "Sva prava zadržana."
    },

    verse: {
        text: "I reci: „Gospodaru moj, povećaj mi znanje!“",
        source: "Kur’an, 20:114"
    },

    home: {
        seoDescription:
            "Besplatne knjige za preuzimanje, video lekcije, audio knjige te kursevi učenja Kur’ana i stranih jezika Instituta Germa.",
        hero: {
            eyebrow: "Dobro došli",
            intro:
                "Institut Germa je kulturna i obrazovna ustanova. Izdajemo vjerske, jezičke i obrazovne knjige, pripremamo video lekcije i organizujemo kurseve učenja Kur’ana i stranih jezika.",
            primaryCta: "Pregledajte izdanja",
            secondaryCta: "Prijavite se na kurs",
            pillars: ["Knjige", "Video lekcije", "Kursevi", "Audio knjige"],
            cue: "Saznajte više",
            category: "Izdanje",
            viewBook: "Pogledaj knjigu",
            previous: "Prethodna knjiga",
            next: "Sljedeća knjiga",
            goTo: "Idi na knjigu {number}"
        },
        marquee: {
            rowOne: ["Izdavaštvo", "Prijevodi", "Kursevi Kur’ana", "Video lekcije", "Audio knjige", "Strani jezici"],
            rowTwo: ["Kur’ansko pismo", "Tedžvid", "Znanje", "Odgoj", "Naslijeđe", "Savremena metoda"]
        },
        about: {
            eyebrow: "O institutu",
            title: "U službi znanja i obrazovanja",
            intro:
                "Naš rad ima za cilj da ljudima pomogne da uče, da bolje upoznaju svoju vjeru i da razvijaju jezičko znanje. Zato pazimo da naše knjige i nastavni materijali budu sadržajno tačni i jasno objašnjeni, a da kursevi budu prilagođeni znanju i potrebama polaznika.",
            features: [
                "Izdavanje i prevođenje vjerske, jezičke i obrazovne literature.",
                "Kursevi učenja Kur’ana i stranih jezika, online i u učionici.",
                "Video lekcije i audio knjige koje možete pratiti na internetu."
            ]
        },
        stats: {
            titles: "Objavljenih naslova",
            languages: "Jezika izdanja",
            fields: "Oblasti djelovanja",
            online: "Pristup online"
        },
        services: {
            eyebrow: "Šta nudimo",
            title: "Naše djelovanje",
            more: "Saznajte više",
            items: {
                libra: {
                    title: "Knjige",
                    description:
                        "Vjerske, jezičke i obrazovne knjige koje je pripremio ili preveo Institut Germa.",
                    cta: "Pogledajte knjige"
                },
                videoleksione: {
                    title: "Video lekcije",
                    description: "Video lekcije o učenju Kur’ana i drugim vjerskim i obrazovnim temama.",
                    cta: "Pratite video lekcije"
                },
                kurse: {
                    title: "Kursevi",
                    description: "Kursevi učenja Kur’ana i stranih jezika, u učionici i online.",
                    cta: "Pogledajte kurseve"
                },
                audiolibra: {
                    title: "Audio knjige",
                    description: "Naša izdanja u audio formatu, za one koji ih radije slušaju.",
                    cta: "Slušajte audio knjige"
                }
            }
        },
        booksLocal: {
            title: "Knjige na bosanskom",
            description: "Naša izdanja na bosanskom jeziku, sva besplatna za preuzimanje."
        },
        booksOther: {
            title: "Knjige na drugim jezicima",
            description: "Naša izdanja na albanskom i drugim jezicima, također besplatna za preuzimanje."
        },
        booksCarouselTitle: "Knjige koje ostavljaju trag",
        booksCarouselDescription:
            "Vjerska, obrazovna i kulturna djela, pažljivo pripremljena za čitaoca.",
        seeAllBooks: "Pogledaj sve knjige",
        mostRead: {
            eyebrow: "Izbor čitalaca",
            title: "Najčitanije",
            description: "Knjige koje naši čitaoci najčešće otvaraju i preuzimaju."
        },
        kurani: {
            badge: "Poseban projekat",
            title: "Plemeniti Kur’an",
            subtitle: "Prijevod značenja na albanski jezik",
            text: "Čitajte Kur’an uz prijevod njegovih značenja na albanski jezik, koji je uradio Jusuf H. Kastrati. Prijevod je besplatno dostupan na Kurani.info.",
            cta: "O prijevodu",
            readOn: "Čitajte na Kurani.info",
            logoAlt: "Logo platforme Kurani.info",
            highlights: [
                {
                    title: "Tačnost i vjernost",
                    text: "Pažljivo prenošenje značenja ajeta, uz oslanjanje na pouzdane tefsire."
                },
                {
                    title: "Jasan i tečan albanski",
                    text: "Prirodan albanski jezik koji, koliko to jezik dopušta, čuva osobenosti kur’anskog izraza."
                },
                {
                    title: "Objašnjenja u fusnotama",
                    text: "Kratka pojašnjenja koja pomažu razumijevanju ajeta tamo gdje je to potrebno."
                }
            ]
        }
    },

    cta: {
        eyebrow: "Pridružite nam se",
        title: "Za prijavu na kurs, narudžbu izdanja ili saradnju, kontaktirajte nas.",
        primary: "Pogledajte kurseve",
        secondary: "Kontaktirajte nas"
    },

    books: {
        seoTitle: "Islamske knjige",
        seoDescription:
            "Katalog Instituta Germa: vjerske, obrazovne i kulturne knjige na bosanskom, albanskom i drugim jezicima, uz profesionalan prijevod i redakturu.",
        listName: "Izdanja Instituta Germa",
        title: "Naša izdanja",
        description:
            "Ovdje ćete pronaći naša izdanja na bosanskom, albanskom i drugim jezicima, sva besplatna za preuzimanje.",
        crumb: "Knjige",
        searchLabel: "Pretraži knjige",
        searchPlaceholder: "Pretražite po naslovu ili autoru",
        authorChip: "Autor: {name}",
        clearAuthor: "Ukloni filter autora",
        clearSearch: "Očisti pretragu",
        categoryLabel: "Kategorija",
        allCategories: "Sve kategorije",
        languageLabel: "Jezik",
        allLanguages: "Svi jezici",
        readingList: "Moja lista za čitanje",
        readingListHintBefore: "Pritisnite ikonu",
        readingListHintAfter: "na knjizi da biste je sačuvali ovdje.",
        readingListEmpty:
            "Vaša lista za čitanje je još prazna. Pritisnite oznaku na svakoj knjizi koju želite pročitati kasnije.",
        foundOne: "Pronađena je 1 knjiga",
        foundMany: "Broj pronađenih knjiga: {count}",
        noResults: "Nijedna knjiga ne odgovara ovim kriterijima.",
        showAll: "Prikaži sve knjige",
        groupLocal: "Na bosanskom",
        groupOther: "Na drugim jezicima",
        mostRead: "Najčitanije",
        publishedBy: "Izdanje Instituta Germa",
        viewBook: "Pogledaj knjigu {title}",
        coverAlt: "Naslovnica knjige {title}",
        save: "Sačuvaj na moju listu",
        saved: "Na mojoj listi",
        remove: "Ukloni s moje liste"
    },

    bookPage: {
        lang: "bs",
        dir: "ltr",
        about: "O knjizi",
        highlights: "Ključne tačke",
        details: "Detalji",
        language: "Jezik",
        languageName: "Bosanski",
        category: "Kategorija",
        author: "Autor",
        authorLine: "Autor: {author}.",
        publishedBy: "Izdanje Instituta Germa.",
        fallbackDescription: "{title}. Knjiga na jeziku: {language}.",
        publisher: "Izdavač",
        cta: "Zainteresovani ste za ovu knjigu? Pišite nam za narudžbu ili dodatne informacije.",
        contact: "Kontaktirajte nas",
        home: "Početna",
        books: "Knjige",
        book: "Knjiga",
        breadcrumb: "Putanja stranice",
        coverAlt: "Naslovnica knjige {title}",
        readOnline: "Čitaj online",
        orderOrAsk: "Naruči ili pitaj",
        allBooks: "Sve knjige",
        readerTitle: "Čitajte knjigu online",
        readerText: "Prelistajte cijelu knjigu ovdje, besplatno.",
        openNewTab: "Otvori u novoj kartici",
        relatedEyebrow: "Nastavite čitati",
        moreByAuthor: "Druge knjige ovog autora",
        allByAuthor: "Sve knjige ovog autora",
        authorLinkTitle: "Pogledaj knjige ovog autora",
        relatedTitle: "Moglo bi vas zanimati",
        seeAllBooks: "Pogledaj sve knjige",
        otherEditions: "Ova knjiga na drugim jezicima",
        watchVideos: "Pogledajte video lekcije",
        downloadPdf: "Preuzmi PDF",
        continueFrom: "Nastavi od stranice {page}",
        startOver: "Počni od početka",
        page: "Stranica",
        pageOf: "od",
        prevPage: "Prethodna stranica",
        nextPage: "Sljedeća stranica",
        zoomIn: "Uvećaj",
        zoomOut: "Umanji",
        fullscreen: "Cijeli ekran",
        closeReader: "Zatvori čitač",
        loadingBook: "Knjiga se otvara…",
        readerError: "Knjiga se ovdje nije mogla otvoriti. Pokušajte je otvoriti u novoj kartici.",
        saveBook: "Sačuvaj na moju listu",
        savedBook: "Na mojoj listi",
        share: "Podijeli",
        copyLink: "Kopiraj link",
        linkCopied: "Link je kopiran",
        email: "E-mail",
        moreOptions: "Više opcija",
        displaySettings: "Prikaz za čitanje",
        themeLight: "Dan",
        themeSepia: "Sepija",
        themeNight: "Noć",
        pageSize: "Veličina teksta",
        reviews: {
            title: "Ocjene čitalaca",
            intro: "Kako vam se sviđa ova knjiga? Ostavite ocjenu zvjezdicama i, ako želite, nekoliko riječi za druge čitaoce.",
            average: "{average} od 5",
            count: "Broj ocjena: {count}",
            countOne: "1 ocjena",
            empty: "Ova knjiga još nema ocjena. Budite prvi koji će je ocijeniti.",
            formTitle: "Ocijenite knjigu",
            ratingLabel: "Vaša ocjena",
            star: "Zvjezdice: {count}",
            starOne: "1 zvjezdica",
            name: "Vaše ime",
            namePlaceholder: "npr. Amra",
            comment: "Komentar (nije obavezan)",
            commentPlaceholder: "Šta vam se svidjelo u ovoj knjizi?",
            submit: "Pošalji ocjenu",
            sending: "Slanje…",
            success: "Hvala! Vaša ocjena će se pojaviti nakon što je Institut pregleda.",
            errorRating: "Molimo odaberite koliko zvjezdica dajete knjizi.",
            errorName: "Molimo upišite svoje ime (najmanje dva slova).",
            errorThrottled: "Danas ste poslali mnogo ocjena. Pokušajte ponovo sutra.",
            error: "Ocjena nije poslana. Pokušajte ponovo za trenutak.",
            moderated: "Ocjene se pojavljuju nakon što ih Institut pregleda."
        },
        quote: {
            button: "Podijeli citat",
            title: "Podijelite citat",
            intro: "Označite mišem ili prstom rečenicu na stranici knjige ili je napišite ovdje. Pretvorit ćemo je u sliku za Instagram ili WhatsApp.",
            textLabel: "Citat",
            placeholder: "Napišite ili zalijepite rečenicu koja vas je dirnula…",
            formatLabel: "Oblik slike",
            square: "Kvadrat (objava)",
            story: "Uspravno (priča)",
            share: "Podijeli sliku",
            download: "Preuzmi sliku",
            copyText: "Kopiraj tekst",
            copied: "Tekst je kopiran",
            close: "Zatvori",
            tooLong: "Citat je predug. Molimo skratite ga (do {max} znakova).",
            empty: "Napišite citat da se pojavi na slici.",
            fromSelection: "Podijeli kao citat",
            preview: "Pregled slike",
            shareText: "Iz knjige „{title}“"
        }
    },

    share: {
        share: "Podijeli",
        copyLink: "Kopiraj link",
        linkCopied: "Link je kopiran",
        email: "E-mail",
        moreOptions: "Više opcija"
    },

    audiobooks: {
        seoTitle: "Islamske audio knjige na albanskom",
        seoDescription:
            "Vjerske i obrazovne audio knjige na albanskom jeziku, jasno i profesionalno pročitane. Slušajte ih direktno na stranici, bilo kada i s bilo kojeg uređaja.",
        listName: "Audio knjige Instituta Germa",
        title: "Audio knjige na albanskom",
        description:
            "Naša izdanja u audio formatu, na albanskom jeziku. Možete ih slušati direktno na ovoj stranici ili ih besplatno preuzeti, bez registracije.",
        crumb: "Audio knjige",
        comingSoon: "Uskoro",
        comingSoonText: "Naše audio knjige su u pripremi. Pratite naše kanale da ih poslušate među prvima.",
        badge: "Audio knjiga",
        author: "Autor:",
        openBook: "Otvori knjigu",
        resumeFrom: "Nastavi od {time}",
        back15: "15 sekundi nazad",
        forward15: "15 sekundi naprijed",
        play: "Pusti",
        pause: "Pauziraj",
        position: "Pozicija slušanja",
        speedGroup: "Brzina slušanja",
        speed: "Brzina",
        speedValue: "Brzina {value}",
        download: "Preuzmi audio knjigu",
        youtube: "Slušaj na YouTubeu",
        miniLabel: "Sada slušate",
        closePlayer: "Zatvori plejer",
        openAudiobook: "Idi na audio knjigu",
        coverAlt: "Naslovnica audio knjige {title}",
        otherAudiobooks: "Još audio knjiga",
        allAudiobooks: "Sve audio knjige",
        openPage: "Otvori stranicu audio knjige",
        pageSeoDescription: "Slušajte besplatno audio knjigu „{title}“ na albanskom, direktno na stranici, ili je preuzmite bez registracije."
    },

    videos: {
        seoTitle: "Video lekcije za učenje čitanja Kur’ana",
        seoDescription:
            "Besplatne video lekcije ({count}) za učenje harfova Kur’ana, na albanskom, njemačkom i engleskom, od prvog harfa do tečnog čitanja.",
        listName: "Video lekcije Instituta Germa",
        title: "Naučite čitati Kur’an",
        description:
            "Video lekcije Kur’anskog pisma pomažu vam da korak po korak naučite arapske harfove i čitanje Kur’ana. Lekcije su na albanskom, njemačkom i engleskom jeziku i možete ih besplatno pratiti na ovoj stranici, bez registracije.",
        crumb: "Video lekcije",
        chooseLanguage: "Odaberite jezik:",
        player: {
            videos: "videa",
            youtube: "Pratite na YouTubeu",
            list: "Spisak lekcija",
            promo: "Uvodni video",
            promoShort: "Uvod",
            lesson: "Lekcija",
            of: "od",
            playing: "Trenutno se prikazuje",
            shareLesson: "Podijeli lekciju",
            openBook: "Pogledaj knjigu",
            markDone: "Označi kao naučeno",
            done: "Naučeno",
            progress: "naučeno",
            resume: "Nastavi s:",
            lessonsDone: "{done} od {total} lekcija naučeno",
            progressLabel: "Napredak u ovoj seriji",
            seriesDone: "Završili ste ovu seriju. Svaka čast!",
            progressHint: "Označite lekcije koje ste naučili i pratite svoj napredak.",
            prevLesson: "Prethodna lekcija",
            nextLesson: "Sljedeća lekcija",
            allLessons: "Sve lekcije serije",
            watchOnYoutube: "Pogledaj na YouTubeu",
            aboutLesson: "O ovoj lekciji",
            backToSeries: "Nazad na seriju",
            openLessonPage: "Otvori stranicu lekcije",
            lessonIntro: "Lekcija {number} od {total} iz serije „{series}“.",
            promoIntro: "Uvodni video serije „{series}“.",
            freeLesson: "Besplatna video lekcija Instituta Germa, bez registracije."
        }
    },

    courses: {
        seoTitle: "Kursevi Kur’ana i jezika",
        seoDescription:
            "Kursevi Kur’ana od prvih harfova do učenja s tedžvidom, kao i kursevi jezika. Online i u učionici, prijave su otvorene.",
        listName: "Kursevi Instituta Germa",
        title: "Kursevi učenja Kur’ana i jezika",
        description:
            "Organizujemo kurseve za početnike i za one koji žele unaprijediti svoje znanje. Nastava se, zavisno od kursa i grupe, održava online ili u učionici.",
        crumb: "Kursevi",
        posterAlt: "Plakat kursa {title}",
        teacher: "Učiteljica:",
        details: "Pogledajte detalje kursa",
        listTitle: "Naši kursevi",
        listDescription:
            "Organizujemo kurseve čitanja Kur’ana i tedžvida, a planiramo i ponovno pokretanje kursa arapskog jezika. Datumi, raspored i način prijave objavljuju se za svaku novu grupu.",
        registerTitle: "Želite li se prijaviti na kurs?",
        registerDescription:
            "Popunite formular kako biste nam iskazali interes. Čim se otvori nova grupa za kurs koji ste odabrali, javit ćemo vam se s datumom početka, rasporedom i načinom održavanja nastave.",
        plannedSuffix: "planira se ponovno pokretanje",
        contactFallback: "Kontaktirajte nas",
        items: {
            "shkronjat-e-kuranit": {
                title: "Učenje čitanja Kur’ana",
                description:
                    "Kurs za početnice, prema knjizi Kur’ansko pismo. Nastava počinje upoznavanjem i izgovorom arapskih harfova, a nastavlja se njihovim spajanjem u riječi i vježbama čitanja Kur’ana.",
                level: "Za početnice",
                format: "Online",
                badge: "Za početnike",
                summary:
                    "Kurs prema knjizi Kur’ansko pismo, koji počinje upoznavanjem i izgovorom arapskih harfova, a nastavlja se njihovim spajanjem u riječi i vježbama čitanja.",
                cta: "Raspitajte se o novim grupama"
            },
            "leximi-me-texhvid": {
                title: "Učenje tedžvida",
                description:
                    "Učenje i primjena pravila tedžvida, uz praktične vježbe i ispravljanje čitanja.",
                level: "Za one koji znaju čitati Kur’an",
                format: "Online",
                badge: "",
                summary: "",
                cta: "Raspitajte se o novim grupama"
            },
            "gjuha-arabe": {
                title: "Arapski jezik",
                description:
                    "Kurs čitanja, pisanja i razumijevanja arapskog jezika. Detalji će biti objavljeni kada se odredi ponovni početak kursa.",
                level: "Planira se ponovno pokretanje",
                format: "Online",
                badge: "",
                summary: "",
                cta: "Kontaktirajte nas za više informacija"
            }
        }
    },

    courseForm: {
        name: "Ime i prezime",
        phone: "Broj telefona",
        email: "E-mail adresa",
        course: "Kurs koji vas zanima",
        message: "Poruka",
        optional: "(neobavezno)",
        messagePlaceholder: "Napišite svoja pitanja ili zahtjeve.",
        notice: "Popunjavanje formulara ne predstavlja konačnu prijavu na kurs.",
        submit: "Pošaljite zahtjev",
        submitting: "Šalje se…",
        successTitle: "Zahtjev je poslan",
        successText:
            "Hvala na interesu. Javit ćemo vam se kada se otvori nova grupa za kurs koji ste odabrali.",
        again: "Pošaljite novi zahtjev",
        errors: {
            name: "Molimo upišite svoje ime.",
            phone: "Molimo upišite ispravan broj telefona.",
            email: "Molimo upišite ispravnu e-mail adresu.",
            course: "Molimo odaberite kurs.",
            generic: "Zahtjev nije poslan. Molimo pokušajte ponovo."
        }
    },

    contact: {
        seoTitle: "Kontakt",
        seoDescription:
            "Pišite Institutu Germa za narudžbu knjiga, prijavu na kurseve Kur’ana i jezika ili saradnju. Odgovaramo u najkraćem mogućem roku.",
        title: "Kontaktirajte nas",
        description:
            "Pišite nam za narudžbu knjiga, prijavu na kurs, saradnju ili pitanja o našem radu.",
        crumb: "Kontakt",
        howTitle: "Kako nas kontaktirati?",
        howText: "Možete nam pisati e-mailom ili putem formulara.",
        email: "E-mail",
        response: "Odgovor",
        responseValue: "U roku od 3 dana",
        follow: "Pratite nas na društvenim mrežama"
    },

    contactForm: {
        name: "Ime i prezime",
        namePlaceholder: "Vaše ime i prezime",
        email: "E-mail adresa",
        emailPlaceholder: "vi@primjer.com",
        subject: "Tema",
        optional: "(neobavezno)",
        subjectPlaceholder: "O čemu nam pišete?",
        message: "Poruka",
        messagePlaceholder: "Ovdje napišite svoju poruku.",
        submit: "Pošaljite poruku",
        submitting: "Šalje se…",
        successTitle: "Hvala vam!",
        successText: "Vaša poruka je uspješno poslana. Odgovorit ćemo vam što je prije moguće.",
        again: "Pošaljite novu poruku",
        errors: {
            name: "Molimo upišite svoje ime.",
            email: "Molimo upišite ispravnu e-mail adresu.",
            message: "Molimo napišite nešto dužu poruku.",
            generic: "Poruka nije poslana. Molimo pokušajte ponovo."
        }
    },

    about: {
        seoTitle: "O nama",
        seoDescription:
            "Institut Germa je kulturna i obrazovna ustanova koju je osnovao Jusuf Kastrati, posvećena izdavaštvu, prevođenju te kursevima Kur’ana i jezika.",
        title: "Institut Germa",
        description: "U službi znanja i obrazovanja, kroz knjige i nastavu.",
        crumb: "O nama",
        missionTitle: "Naša misija",
        mission: [
            "Institut Germa je kulturna i obrazovna ustanova koja djeluje u oblasti izdavaštva, prevođenja i nastave. Izdajemo vjersku, jezičku i obrazovnu literaturu, organizujemo kurseve učenja Kur’ana i jezika te pripremamo video lekcije i nastavne materijale.",
            "Pri pripremi izdanja posebnu pažnju posvećujemo tačnosti sadržaja, kvalitetu prijevoda i jezičkoj redakturi. Na kursevima objašnjenja kombinujemo s praktičnim vježbama, prema nivou i potrebama polaznika."
        ],
        valuesTitle: "Načela našeg rada",
        values: [
            {
                title: "Tačnost",
                text: "Oslanjamo se na pouzdane izvore i prije objavljivanja provjeravamo sadržaj, vodeći računa o vjerskoj i jezičkoj tačnosti."
            },
            {
                title: "Jasnoća",
                text: "Koristimo tečan jezik i razumljiva objašnjenja te pojašnjavamo pojmove i teme koje traže predznanje."
            },
            {
                title: "Briga o polazniku",
                text: "Nastavu prilagođavamo uzrastu i znanju polaznika, dajemo prostor pitanjima i pomažemo im da napreduju korak po korak."
            },
            {
                title: "Odgovornost",
                text: "Rado primamo primjedbe i prijedloge i ispravljamo greške uočene u našim izdanjima i materijalima."
            }
        ],
        leadership: "Rukovodstvo",
        founderShort: "Osnivač i direktor",
        portraitAlt: "Portret: {name}",
        directorRole: "Osnivač i direktor Instituta Germa",
        directorBio: [
            "Institutom Germa rukovodi njegov osnivač i direktor Jusuf Kastrati. Diplomirao je na Šerijatskom fakultetu Islamskog univerziteta „Imam Muhammed ibn Su’ud“ u Rijadu, na odsjeku za islamsko pravo i njegove osnove. Na istom univerzitetu završio je i magistarske studije iz islamske kulture, a trenutno je na doktorskim studijama iz islamske civilizacije na Univerzitetu Ez-Zitouna u Tunisu.",
            "Ima dugogodišnje iskustvo u prevođenju islamske literature i u nastavi. Preveo je vjerske knjige i držao kurseve učenja Kur’ana i arapskog jezika, uz objašnjenja na albanskom i njemačkom jeziku. Poseban dio svog rada posvetio je vjerskom odgoju mladih."
        ]
    },

    kurani: {
        seoTitle: "Plemeniti Kur’an s prijevodom značenja na albanski",
        seoDescription:
            "Čitajte arapski tekst Kur’ana uz prijevod njegovih značenja na albanski jezik, koji je uradio Jusuf Kastrati, besplatno na Kurani.info.",
        title: "Plemeniti Kur’an",
        subtitle: "Prijevod značenja na albanski jezik",
        description:
            "Čitajte Kur’an uz prijevod njegovih značenja na albanski jezik, koji je uradio Jusuf H. Kastrati. Prijevod je besplatno dostupan na Kurani.info.",
        crumb: "Kur’an",
        readOn: "Čitajte na Kurani.info",
        logoAlt: "Logo platforme Kurani.info",
        aboutTitle: "O prijevodu",
        about: [
            "Ovaj prijevod pripremljen je kako bi albanskom čitaocu značenja ajeta prenio tačno, jasnim i tečnim albanskim jezikom. Rad se oslanja na pouzdane tefsire i prošao je brojne vjerske i jezičke recenzije.",
            "Svaki prijevod je ljudski napor da se prenesu značenja ajeta i ne može u potpunosti odraziti jezičko i značenjsko bogatstvo originala. Zato on služi kao pomoć u razumijevanju Kur’ana, dok je sam Kur’an Knjiga koju je Allah objavio na arapskom jeziku."
        ],
        featuresTitle: "Odlike prijevoda",
        features: [
            {
                title: "Tačnost i vjernost",
                text: "Pažnja u prenošenju značenja ajeta, uz oslanjanje na pouzdane tefsire."
            },
            {
                title: "Jasan i tečan albanski",
                text: "Jasan i tečan albanski jezik koji, koliko to jezik dopušta, čuva osobenosti kur’anskog izraza."
            },
            {
                title: "Ujednačen stil i terminologija",
                text: "Ujednačena upotreba terminologije i čuvanje islamskih pojmova ustaljenih u albanskom jeziku."
            },
            {
                title: "Kratke fusnote",
                text: "Pojašnjenja koja čitaocu pomažu da razumije ajete tamo gdje je potrebno dodatno objašnjenje."
            },
            {
                title: "Vjerska i jezička recenzija",
                text: "Višestruke provjere stručnjaka iz odgovarajućih oblasti, radi tačnosti značenja i albanskog izraza."
            },
            {
                title: "Slobodan pristup",
                text: "Prijevod se može besplatno čitati na internetu. Elektronska verzija omogućava njegovo ažuriranje novim ispravkama i poboljšanjima."
            }
        ],
        translatorBadge: "Prevodilac",
        translatorRole: "Doktorand iz islamske civilizacije",
        translatorText:
            "Prijevod značenja Plemenitog Kur’ana na albanski jezik plod je dugogodišnjeg istraživačkog, prevodilačkog i redakcijskog rada.",
        teamTitle: "Tim za redakciju i recenziju",
        roles: {
            religious: "Vjerska redakcija",
            consulting: "Vjersko savjetovanje",
            language: "Jezička redakcija"
        },
        noteTitle: "Napomena",
        note: "Ovaj prijevod je u završnoj fazi redakcije i naučne recenzije. Rado primamo svaku primjedbu i prijedlog koji može pomoći da se značenja Plemenitog Kur’ana prenesu što tačnije.",
        writeUs: "Pišite nam",
        ctaTitle: "Čitajte prijevod",
        ctaText: "Arapski tekst, prijevod na albanski i pojašnjenja u fusnotama pronaći ćete na Kurani.info.",
        ctaButton: "Otvorite Kurani.info"
    },

    search: {
        open: "Pretraga",
        title: "Pretražite portal",
        placeholder: "Tražite knjige, audio knjige, video lekcije, kurseve…",
        close: "Zatvori pretragu",
        hint: "Upišite najmanje dva slova za pretragu.",
        empty: "Nema rezultata za „{query}“.",
        error: "Pretraga nije uspjela. Pokušajte ponovo za trenutak.",
        loading: "Pretraga u toku…",
        groups: {
            books: "Knjige",
            audiobooks: "Audio knjige",
            videos: "Video lekcije",
            courses: "Kursevi"
        }
    },

    offline: {
        title: "Niste povezani na internet",
        text: "Ova stranica još nije sačuvana na ovom uređaju. Pokušajte ponovo kada se povežete na internet. U međuvremenu možete čitati knjige koje ste ranije otvorili.",
        retry: "Pokušaj ponovo",
        home: "Početna stranica",
        savedTitle: "Knjige sačuvane za čitanje bez interneta",
        savedEmpty: "Još nemate sačuvanih knjiga. Svaka knjiga koju otvorite u čitaču na stranici automatski se čuva na ovom uređaju."
    },

    pwa: {
        install: "Instaliraj aplikaciju"
    },

    notFound: {
        title: "Stranica nije pronađena",
        text: "Stranica je možda premještena ili više ne postoji. Vratite se na početnu stranicu i nastavite svoje putovanje kroz znanje.",
        back: "Nazad na početnu"
    },

    serverError: {
        title: "Nešto nije u redu",
        text: "Došlo je do neočekivane greške s naše strane. Molimo pokušajte ponovo za nekoliko trenutaka.",
        back: "Nazad na početnu"
    }
}
